@if (user) {
  <div #sidePanelComponent>
    <pp-side-panel-backdrop
      [ppSidePanel]="sidePanel"
      (ppClose)="closePanel()"
    ></pp-side-panel-backdrop>
    @if (sidePanel.notificationsExpanded) {
      <div
        class="sidePanel__close-notifications"
        (click)="toggleNotifications()"
        [class.hiddenMobile]="isMobile"
      >
        <img class="sidePanel__close-notifications-image" [src]="EIconPath.INTERACTION_CLOSE" />
      </div>
    }
    @if (!sidePanel.expanded && isMobile) {
      @if (rebrandEnabled()) {
        <pp-icon
          class="sidePanel__mobile-button"
          ppClass="setSize18"
          [ppSVG]="iconMap[EIconPath.SIDE_PANEL_MENU]"
          (click)="togglePanel()"
        ></pp-icon>
      } @else {
        <img
          class="sidePanel__mobile-button"
          [src]="EIconPath.SIDE_PANEL_MENU"
          (click)="togglePanel()"
        />
      }
    }
    <div
      class="filterPanel sidebar__animation"
      [class.sidePanelBody--expanded]="
        sidePanel.expanded && (!isMobile || sidePanel.rightPanelExpanded)
      "
      [class.filterPanel--hidden]="sidePanel.hidden"
      [class.sidePanelBody--collapsedMobile]="
        !sidePanel.expanded && isMobile && !sidePanel.rightPanelExpanded
      "
      data-testid="side-panel-body"
    >
      <div class="sidePanel__left" data-testid="side-panel-left">
        @if (showBackArrow) {
          <pp-side-panel-back [ppDisabled]="disabled"></pp-side-panel-back>
        }
        @if (!showBackArrow) {
          <pp-side-panel-logo [ppMobile]="isMobile"></pp-side-panel-logo>
        }
        <div class="sidePanel__mainContent">
          <pp-side-panel-dashboard
            [ppRouterPath]="routerPath"
            [ppActiveWorkspaceId]="user.activeWorkspaceId"
            [ppDisabled]="disabled"
          ></pp-side-panel-dashboard>
          <pp-side-panel-overview
            [ppTimelineEnabled]="timelineEnabled"
            [ppRouterPath]="routerPath"
            [ppDisabled]="disabled"
          ></pp-side-panel-overview>
          @if (timelineEnabled) {
            <pp-side-panel-timeline
              [ppRouterPath]="routerPath"
              [ppDisabled]="disabled"
            ></pp-side-panel-timeline>
          }
          <pp-side-panel-sites
            [ppIsMobile]="isMobile"
            [ppDisabled]="disabled"
          ></pp-side-panel-sites>
          @if (fleetManagementEnabled) {
            <pp-side-panel-fleet-management
              [ppRouterPath]="routerPath"
              [ppDisabled]="disabled"
            ></pp-side-panel-fleet-management>
          }
        </div>
        <div class="sidePanel__endContent">
          <pp-side-panel-reminders
            [ppRouterPath]="routerPath"
            [ppActiveWorkspaceId]="user.activeWorkspaceId"
            [ppDisabled]="disabled"
          ></pp-side-panel-reminders>
          <pp-side-panel-notifications
            [ppUser]="user"
            [ppDisabled]="disabled"
          ></pp-side-panel-notifications>
          <pp-side-panel-user [ppUser]="user" [ppDisabled]="disabled"></pp-side-panel-user>
        </div>
      </div>
      @if ((!isMobile && sidePanel.expanded) || (isMobile && sidePanel.rightPanelExpanded)) {
        <pp-side-panel-sites-list></pp-side-panel-sites-list>
      }
    </div>
    <pp-notifications
      class="notificationsPanel sidebar__animation"
      [ngClass]="sidePanel.expanded ? 'notificationsPanel--right' : ''"
      [class.notificationsPanel--collapsed]="!sidePanel.notificationsExpanded"
      [ppExpanded]="sidePanel.notificationsExpanded"
    ></pp-notifications>
  </div>
}
